import React from 'react';
import { useGoogleFormModal } from '../App';

const CtaOne = () => {
  const { openGoogleFormModal } = useGoogleFormModal();
  return (
    <section className="cta-one">
      <div className="container">
        <div className="cta-one__inner">
          <div className="cta-one-bg" style={{ backgroundImage: "url(https://images.pexels.com/photos/30517382/pexels-photo-30517382.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)", backgroundSize: "cover", backgroundPosition: "top", backgroundRepeat: "no-repeat", backgroundAttachment: "fixed" }}>
          </div>
          <h2 className="cta-one__title">We are creators, dreamers, and builders of worlds.</h2>
          <p className="cta-one__text">We are not bound by genres, mediums, or stereotypes. We find beauty in color, story in sound, and purpose in collaboration. C2 is where the journey begins—not alone, but together.</p>
          <button
            onClick={openGoogleFormModal}
            className="thm-btn cta-one__btn"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer'
            }}
          >
            Become a Member
          </button>
        </div>
      </div>
    </section>
  );
};

export default CtaOne;
